export var VersionStatus;
(function (VersionStatus) {
    VersionStatus["Archived"] = "archived";
    VersionStatus["Draft"] = "draft";
    VersionStatus["PendingApproval"] = "pending_approval";
    VersionStatus["Published"] = "published";
})(VersionStatus || (VersionStatus = {}));
//# sourceMappingURL=version-status.js.map